module.exports = __webpack_public_path__ + "img/honor-deeds-item-icon.88b544a8.png";